export default __webpack_public_path__ + "static/media/email.96be4e9f.svg";